import React from 'react';

import './TableData.scss';
import { IDocumentTable } from '@models/Forms/IForms';
import { RouteNames } from '@/router/router.types';

export interface OpenDocButtonProps {
    table: IDocumentTable;
    rowData: any;
    docId?: string;
}

const OpenDocButton: React.FC<OpenDocButtonProps> = ({ table, rowData, docId }: OpenDocButtonProps) => {
    let docIdRow = table.previewDocByKey ? rowData[table.previewDocByKey] : undefined;

    return (
        <>
            {docIdRow && (
                <a
                    href={RouteNames.DOCUMENT.replace(':id', docIdRow?.toString())}
                    className="dx-link dx-link-delete dx-icon-doc dx-link-icon"
                    title="Просмотреть"
                    target={'_blank'}
                    aria-label="Просмотреть"
                    rel="noopener,noreferrer"
                />
            )}
        </>
    );
};

export default OpenDocButton;
